<template>
  <div
    :class="[
      'field-container',
      'field-container-' + field.type,
      { 'field-container-full-width': field.type === 'table' },
      { 'field-container-has-hint-text': field.hintText },
      { island: !configurationMode }
    ]"
  >
    <div class="field-wrapper">
      <div
        :class="[
          'field-content',
          configuredField === field.slug ? 'configuring' : null
        ]"
      >
        <div :class="['form-group', { error: validationErrors.length }]">
          <span class="controls">
            <slot name="controls"></slot>
          </span>
          <div v-if="displayLabel" class="field-label">
            <field-label
              :field="field"
              :is-manager="isManager"
              :element-id="elementId"
            />
            <help-icon v-if="field.helpText" :content="field.helpText" />
            <div v-if="displayCounters" class="counters">
              <counters :field="field" :value="value || ''"></counters>
            </div>
          </div>
          <div>
            <slot></slot>
            <validation-errors
              :attribute="attribute"
              :validation-errors="validationErrors"
            />
          </div>
          <slot name="field-footer"></slot>
        </div>
      </div>
      <div class="field-hint-text">
        <div class="hint-text">
          <span v-if="field.hintText" v-html="field.hintText"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Container from './Container.vue';

export default {
  extends: Container,
  computed: {
    ...mapState('entryFormConfiguration', ['configuredField'])
  }
};
</script>
